import i18n from '../language/index'
export function background_set(background) { // 背景颜色
  if(!(background && background.radio_val)) {
    return
  }
  if (background.radio_val === "hidden") {
    return {
      background: "transparent"
    };
  }
  return {
    backgroundColor: background[
      background.radio_val
    ].color,
    backgroundImage:
      "url(" +
      (background[
        background.radio_val
      ].img || "") +
      ")",
    backgroundSize: background[
      background.radio_val
    ].background_size,
    backgroundRepeat:background[
      background.radio_val
    ].background_repeat,
    backgroundPosition: background[
      background.radio_val
    ].background_position
  };
}
export function background_color(background,type = 'color') { // 背景颜色 纯色或者是渐变色
  if(!(background && background.radio_val)) {
    return
  }
  let bg_color = '';
  let color_name = 'color'
  background = background[background.radio_val];
  // infor.form_item_bg[infor.form_item_bg.radio_val].pattern == 'linear_gradient'
  return background.pattern === 'linear_gradient'
    ?`linear-gradient(${background.linear_gradient.deg}deg,
        ${background.linear_gradient.start_color}
        ${background.linear_gradient.start_pointer}%,
        ${background.linear_gradient.end_color}
        ${background.linear_gradient.end_pointer}%)` : background[type]
}

export function font_set(font) { // 字体 字号 颜色 加粗 斜体 下划线
  if(!(font && font.radio_val)) {
    return
  }
  if(font.radio_val === "hidden") return {} // 字体隐藏
  font = font[font.radio_val]
  let fontStyle= {};
  fontStyle.fontSize = font.fontSize + "px"; // 字号 
  fontStyle.fontFamily = font.fontFamily; 
  font.fsWeight && (fontStyle.fontWeight = font.fsWeight);// 是否加粗
  font.fsItalics && (fontStyle.fontStyle = font.fsItalics); // 是否是斜体
  font.fontUnderline && (fontStyle.textDecoration= font.fontUnderline);
  font.textAlign&& (fontStyle.textAlign = font.textAlign); // 对齐方式
  if (font.pattern == "linear_gradient") {
    fontStyle.webkitBackgroundClip = "text";
    fontStyle.webkitTextFillColor = "transparent";
    fontStyle.color = "";
    fontStyle.backgroundImage = 
      `linear-gradient(${font.linear_gradient.deg}deg, ${font.linear_gradient.start_color} ${font.linear_gradient.start_pointer}%,
      ${font.linear_gradient.end_color} ${font.linear_gradient.end_pointer}%)`;
  } else {
    fontStyle.color = font.fontColor;
  }
  return fontStyle;
}


// WEBPACK FOOTER //
// ./src/base/background_set.js